const Data = [
  {
    id: "1",
    title: "Money App - Mobile Version",
    category: "UI UX",
    // price: "UI UX",
    img: require("../assets/image/money.jpg"),
    desc: "Financial management application design on Android.",
  },
  {
    id: "2",
    title: "Fintree - Mobile Version",
    category: "UI UX",
    img: require("../assets/image/fintree.jpg"),
    desc: "The financial management application design is equipped with charts and balances from OVO and Gopay.",
  },
  {
    id: "3",
    title: "Portofolio Site",
    category: "Program",
    img: require("../assets/image/simple-portofolio.jpg"),
    website: "https://portofoliosite.netlify.app/",
    desc: "Portfolio website using HTML, CSS, and Bootstrap.",
  },
  {
    id: "4",
    title: "Gamerich - Mobile Version",
    category: "UI UX",
    img: require("../assets/image/gamerich.jpg"),
    desc: "Top Up game application design, based on android can do top up games easily.",
  },
  {
    id: "5",
    title: "Homey - Website Version",
    category: "UI UX",
    img: require("../assets/image/homey-web.jpg"),
    desc: "Website design for buying and selling houses, which can make it easier for users to get their dream place to live.",
  },
  {
    id: "6",
    title: "Homey - Mobile Version",
    category: "UI UX",
    img: require("../assets/image/homey.jpg"),
    desc: "The design of the home buying and selling application, which can make it easier for users to get their dream place to live.",
  },
  {
    id: "7",
    title: "Freedix - Website Version",
    category: "UI UX",
    img: require("../assets/image/freedix-web.jpg"),
    desc: "Website design watching movies, which consists of several selected movies.",
  },
  {
    id: "8",
    title: "Relax Zone",
    category: "Program",
    img: require("../assets/image/relax-zone.jpg"),
    website: "https://relaxzone.netlify.app/",
    desc: "Website Cafe which is equipped with a food menu filter, in order to make it easier for buyers when ordering food.",
  },
];

export default Data;
